// extracted by mini-css-extract-plugin
export default {"radio-group":"lsf-radio-group","radio-group__buttons":"lsf-radio-group__buttons","radio-group__button":"lsf-radio-group__button","radio-group__button_checked":"lsf-radio-group__button_checked","radio-group__button_disabled":"lsf-radio-group__button_disabled","radio-group__input":"lsf-radio-group__input","radio-group_size_medium":"lsf-radio-group_size_medium","radio-group_size_small":"lsf-radio-group_size_small"};
    if(module.hot) {
      // 1732531523387
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  